<template>
  <v-card flat :loading="isLoading">
    <slot name="header">
      <v-card-title v-if="!hideHeader">
        <slot name="title">Monthly Study Reports</slot>
      </v-card-title>
      <v-divider v-if="!hideHeader"></v-divider>
    </slot>
    <v-card-text>
      <v-list>
        <v-list-group
          v-for="student in monthlyStudyReports"
          :key="student.student_id"
          no-action
        >
          <template #activator>
            <v-list-item-title>
              {{ student.student_name }}
            </v-list-item-title>
          </template>
          <v-list-item v-for="(report, j) in student.reports" :key="j">
            <v-list-item-content>
              <v-row align="center">
                <v-col cols="12" md="4">
                  Study Report Term {{ report.term }} Month
                  {{ report.month }}
                </v-col>
                <v-col cols="12" md="4">
                  <v-progress-linear
                    color="warning"
                    :value="countStudyReportProgress(report)"
                  ></v-progress-linear>
                  <h4 class="text-center">
                    {{ report.items.length }} /
                    {{ report.class_per_week * 4 }} completed
                  </h4>
                </v-col>
                <v-col cols="12" md="4" class="text-right">
                  <v-btn
                    depressed
                    color="success"
                    :href="
                      $route('study-progress.monthly-reports.download-pdf', {
                        classroom_id: classroom.id,
                        student_id: student.student_id,
                        term: report.term,
                        month: report.month,
                      })
                    "
                    target="_blank"
                  >
                    <v-icon left>mdi-cloud-download</v-icon>Download
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ClassroomStudyReportList',
  props: {
    classroomId: {
      type: Number,
      required: true,
    },
    hideHeader: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      itemList: 'studyProgress/monthlyReportList',
      isLoading: 'studyProgress/isMonthlyReportListLoading',
    }),
    monthlyStudyReports() {
      const result = []
      for (const report of this.itemList) {
        const idx = result.findIndex((e) => e.student_id === report.student_id)
        if (idx === -1) {
          result.push({
            student_id: report.student_id,
            student_name: report.student_name,
            reports: [report],
          })
        } else {
          result[idx].reports.push(report)
        }
      }
      return result
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions({
      getItemList: 'studyProgress/getMonthlyReportList',
    }),
    async init() {
      await this.getItemList({
        classroom_id: this.classroomId,
      })
    },
    countStudyReportProgress(report) {
      const total = report.class_per_week * 4
      return (report.items.length / total) * 100
    },
  },
}
</script>
